'use strict';

module.exports = Odigeo.Model.extend({
    defaults: {
        idRow: '',
        idPassenger: -1,
        hasIncludedBaggages: false,
        hasSelectableBaggages: false,
    },
    getDescriptor: function() {
        return Odigeo._.omit(this.getAll(), 'idPassenger', 'idRow');
    },
});
